<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCol xs="12" lg="12" style="margin-top: 20px">
        <CTabs variant="pills">
          <CTab title="Create Tournament">
            <hr />
            <CreateTournament></CreateTournament>
          </CTab>

          <CTab title="Tournament List">
            <hr />
            <TournamentList></TournamentList>
          </CTab>

          <CTab v-if="user.userRole != 'user'" title="Tournament LeaderBoard">
            <TournamentLeaderboard></TournamentLeaderboard>
          </CTab>
          <!-- <CTab title="Tournament Users">
            <hr />
            <TournamentUsers></TournamentUsers>
          </CTab> -->
        </CTabs>
      </CCol>
    </CCard>
  </div>
</template>

<script>
import CreateTournament from "./createTournament.vue";
import TournamentList from "./tournamentList_v2.vue";
import TournamentUsers from "./tournamentPractice.vue";
import TournamentLeaderboard from "./tournamentLeaderboard.vue";
import AddGame from "./addgame.vue";
export default {
  components: {
    TournamentList,
    TournamentUsers,
    AddGame,
    CreateTournament,
    TournamentLeaderboard,
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("data"));
  },
};
</script>

<style></style>
